import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import SelectAdvancedFilter from 'components/lib/SelectAdvancedFilter';
import { SelectAdvancedFilterOptionType } from 'types/common';

type AuditFilterOption = {
  label: string;
  value: number;
};

type Props = {
  typeFilter: number[];
  statusFilter: number[];
  typeOptions: AuditFilterOption[];
  statusOptions: AuditFilterOption[];
  onTypeFilterChange: (value: number[]) => void;
  onStatusFilterChange: (value: number[]) => void;
};

const FiltersRow = styled.div`
  display: flex;
  gap: 5px;
`;

const CommunityAuditsFilters = ({
  typeFilter,
  statusFilter,
  typeOptions,
  statusOptions,
  onTypeFilterChange,
  onStatusFilterChange,
}: Props) => {
  const handleSelectTypes = (values: SelectAdvancedFilterOptionType[]) => {
    onTypeFilterChange((values ?? []).map((item) => Number(item.value)));
  };

  const handleSelectStatuses = (values: SelectAdvancedFilterOptionType[]) => {
    onStatusFilterChange((values ?? []).map((item) => Number(item.value)));
  };

  return (
    <FiltersRow>
      <SelectAdvancedFilter
        className={classNames({ active: typeFilter.length > 0 })}
        placeholder="Audit Type"
        options={typeOptions}
        defaultValue={typeFilter}
        onSelect={handleSelectTypes}
      />
      <SelectAdvancedFilter
        className={classNames({ active: statusFilter.length > 0 })}
        placeholder="Status"
        options={statusOptions}
        defaultValue={statusFilter}
        onSelect={handleSelectStatuses}
      />
    </FiltersRow>
  );
};

export default CommunityAuditsFilters;
